import { render, staticRenderFns } from "./ProductionAssetTypeList.vue?vue&type=template&id=18e78277&scoped=true&"
import script from "./ProductionAssetTypeList.vue?vue&type=script&lang=js&"
export * from "./ProductionAssetTypeList.vue?vue&type=script&lang=js&"
import style0 from "./ProductionAssetTypeList.vue?vue&type=style&index=0&id=18e78277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e78277",
  null
  
)

export default component.exports